var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1bb14d;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #c8d100;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #00482f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 349.2,
    y: 383.1,
    width: 5.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "207.4 395.8 206.5 399.9 195.9 399.9 189.4 430.6 183.8 430.6 190.3 399.9 179.4 399.9 180.3 395.8 207.4 395.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.6 395.8 92.2 395.8 92.2 422.2 109.1 422.2 109.1 430.6 82.6 430.6 82.6 395.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m144.4,413.6c0,11-6.3,18.1-16.6,18.1s-16.6-7.1-16.6-18.1v-.3c0-11,6.3-18.1,16.6-18.1s16.6,7.1,16.6,18.1v.3Zm-5.6,0v-.3c0-8.9-4.5-13.9-11-13.9s-11,5-11,13.9v.3c0,8.9,4.5,13.9,11,13.9s11-5,11-13.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "156.7 404.3 146.3 404.3 146.3 395.8 176.8 395.8 176.8 404.3 166.4 404.3 166.4 430.6 156.7 430.6 156.7 404.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m331.2,400v21.2c0,4,1.3,5.4,4.5,5.4,2.1,0,3.8-.2,6.4-.6v4.4c-2.3.4-4.7.6-6.9.6-6.8,0-9.6-2.9-9.6-10v-21h-5.5v-4.2h5.5v-7.3l5.5-2.3v9.7h11.2v4.2l-11.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 349.1,
    y: 395.8,
    width: 5.6,
    height: 34.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m221.2,394.8c-10.4,0-16.8,7.2-16.8,18.3v.3c0,11.1,6.4,18.3,16.8,18.3s16.8-7.2,16.8-18.3v-.3c0-11.1-6.4-18.3-16.8-18.3m11.1,18.6c0,9.1-4.6,14.1-11.1,14.1s-11.1-5-11.1-14.1v-.3c0-9.1,4.6-14.1,11.1-14.1s11.1,5,11.1,14.1v.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "262.3 409.3 254 395.8 243.8 395.8 243.8 430.6 253.2 430.6 253.2 410.7 262.1 424.3 262.3 424.3 271.2 410.6 271.2 430.6 280.8 430.6 280.8 395.8 270.6 395.8 262.3 409.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m308.3,395.8c-1.7-.7-3.7-1-6.1-1-7.3,0-11.9,4-13.7,9.3l5,1.5c.9-2.4,2.1-4.1,3.7-5.1.9-.6,1.9-1,2.9-1.2.7-.1,1.3-.2,2-.2,5.4,0,7.9,2.9,7.9,8.8v1.2l-4.3.2c-15.2.6-19.7,5.9-19.7,12,0,6.5,5.5,10.4,12.1,10.4,5.3,0,9.6-2.5,12.1-7.1v6.1h5.4v-20.9c0-7.3-2.3-12.1-7.3-14m1.8,21.2c0,5.9-4.5,10.5-11,10.5-4.2,0-7.4-2.2-7.4-6.2,0-4.3,2.9-7.7,14.2-8.3l4.2-.1v4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m379.6,422.5c-4.9,0-8.3-4.1-8.3-9.3v-.1c0-5.1,3.4-9.2,8.3-9.2,3.3,0,5.6,1.6,7.6,4.1l7.3-5.6c-3.1-4.3-7.7-7.3-14.8-7.3-10.5,0-18.4,8-18.4,18.1v.1c0,10.4,8,18,18,18,7.7,0,12.1-3.3,15.4-7.9l-7.3-5.2c-2.1,2.6-4.2,4.3-7.8,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m414,394.8c-7.3,0-11.9,4-13.7,9.3l5,1.5c1.6-4.5,4.7-6.6,8.7-6.6,5.4,0,7.9,2.9,7.9,8.8v1.2l-4.3.2c-15.2.6-19.7,5.9-19.7,12,0,6.5,5.5,10.4,12.1,10.4,5.3,0,9.6-2.5,12.1-7.1v6.1h5.4v-20.8c-.1-9.9-4.4-15-13.5-15m7.8,22.2c0,5.9-4.5,10.5-11,10.5-4.2,0-7.4-2.2-7.4-6.2,0-4.3,2.9-7.7,14.2-8.3l4.2-.1v4.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m406.5,359.9c-.5,1.3-1.3,2.4-2.2,3.3-.9.9-1.9,1.6-3.1,2.1-1.1.5-2.3.7-3.5.7-.9,0-1.8-.1-2.6-.3-.8-.2-1.5-.5-2.1-.9s-1.2-.8-1.7-1.4c-.5-.5-.9-1.1-1.3-1.6v3.8h-3v-28.3h3v12.3c.4-.6.9-1.2,1.4-1.7s1.1-1,1.7-1.4,1.3-.7,2.1-1c.8-.2,1.6-.4,2.5-.4,1.2,0,2.4.2,3.5.7s2.2,1.1,3.1,2,1.6,2,2.2,3.3c.5,1.3.8,2.8.8,4.4,0,1.7-.3,3.2-.8,4.4Zm-2.8-7.5c-.4-1-.9-1.8-1.5-2.4-.6-.7-1.4-1.2-2.2-1.6-.9-.4-1.8-.5-2.7-.5s-1.8.2-2.7.6c-.9.4-1.6.9-2.3,1.6-.7.7-1.2,1.5-1.6,2.4-.4,1-.6,2-.6,3.2s.2,2.2.6,3.2.9,1.8,1.6,2.4c.7.7,1.5,1.2,2.3,1.6.9.4,1.8.6,2.7.6,1,0,1.9-.2,2.7-.5.9-.3,1.6-.8,2.2-1.5s1.1-1.5,1.5-2.4c.4-1,.6-2,.6-3.3-.1-1.4-.2-2.5-.6-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m420.8,366.2c-.9,2.1-1.8,3.5-2.8,4.4s-2.3,1.3-3.8,1.3c-.8,0-1.6-.1-2.2-.3-.7-.2-1.3-.4-2-.8l1-2.4c.5.3,1,.4,1.5.6.5.1,1,.2,1.7.2.9,0,1.7-.3,2.3-.8.6-.5,1.2-1.5,1.8-2.9l-9.1-20h3.3l7.3,16.7,6.4-16.7h3.2l-8.6,20.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.6,321.9c-18.5,0-31.4-18.3-25.2-35.7l58.9-165.3c14.3-40.6,50.6-40.6,62.6-40.6h122.8c65,0,95.9,35.9,97.7,71.6.7,14.7-3.2,28.6-10.8,40.4,7.7,11.2,11.5,24.2,11.5,36.8,0,44.5-44.2,92.7-115.7,92.9H109.6v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m160,126.9c8.9-25.5,28.2-28.9,46-28.9h122.8c57.1,0,78.9,29.5,80.1,54.8.5,10.6-2.3,21-8.1,30.1l-6.3,9.8,6.6,9.6c5.4,7.8,8.4,17.3,8.4,26.8,0,36.1-37.5,75.1-98.1,75.3H115.6c-9.2,0-15.7-9.1-12.6-17.9l57-159.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m345.3,195.8c60.2-6,67.9-80.3-16.5-80.3h-122.9c-14.8,0-24.1,2.1-29.4,17.2l-51.7,145.1c-1.5,4.3,1.7,8.9,6.3,8.9h180.3c86-.1,112-90.9,33.9-90.9Zm-42,55.9l-112.8-.5,13.2-36.6,108-.2c37.5.2,28.3,37.3-8.4,37.3Zm7.7-69.6l-95.7-.2,12.2-33.6h92.2c27,0,21.9,33.8-8.7,33.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetter);
export default __webpack_public_path__ + "static/media/better.c3f9b7fb72ca839bd9b8e32651f710dc.svg";
export { ForwardRef as ReactComponent };